import React, { FunctionComponent } from 'react';
import { FormProvider } from 'react-hook-form';

import { Box, Typography } from '@sbv-clients/ui-shared';

import SharedAuthLayout from '../../layouts/shared-auth-layout';
import { useVerifyPhoneNumberResult } from './providers/verify-phone-number.provider';
import { VerifyPhoneFormBody } from './verify-phone-form-body';

export const VerifyPhoneForm: FunctionComponent = () => {
  const { methods, handleSubmit } = useVerifyPhoneNumberResult();

  return (
    <SharedAuthLayout>
      <Box mb={6} textAlign="center">
        <Typography variant="h1" fontWeight={700} mb={2}>
          Verify your phone number
        </Typography>
        <Typography>
          We’ll text you a one-time code to sign up or reset your password.
        </Typography>
      </Box>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <VerifyPhoneFormBody />
        </form>
      </FormProvider>
    </SharedAuthLayout>
  );
};
